// @flow
import React, { useEffect, type Node } from 'react';
import { Trans } from 'react-i18next';

import Modal, { ModalHeader } from 'app/common/components/Modal';
import Loading from 'app/common/components/Loader';

import type { SolutionCreateRequestParams, SolutionType } from '../SolutionsData';


type Props = {
  createParams: SolutionCreateRequestParams,
  onCreateSolution: (params: SolutionCreateRequestParams) => Promise<SolutionType | null>,
  onCreateSuccess: (solutionId: number) => void,
  onCreateFail: () => void,
}

const CreateSolutionModal = ({
  createParams,
  onCreateSolution,
  onCreateSuccess,
  onCreateFail,
}: Props): Node => {
  useEffect(() => {
    (async () => {
      const res = await onCreateSolution(createParams);
      if (res) {
        const { id } = res;
        onCreateSuccess(id);
        return;
      }
      onCreateFail();
    })();
  }, []);

  return (
    <Modal>
      <ModalHeader>
        <Trans i18nKey="dnevnik:dnevnik_solution_create_modal_header">
          {'Создание решения задания'}
        </Trans>
      </ModalHeader>

      <Loading />
    </Modal>
  );
};

export default CreateSolutionModal;
